import React, {Context} from "react";

const GlobalMessageContext: Context<((message: string) => void) | undefined> =
    React.createContext<((message: string) => void) | undefined>(undefined);

export default GlobalMessageContext;
